export const BASE_URL = 'https://admin.easylmd.com/admineasylmd/web/api/'
